import { toast } from "sonner";

export const copy = async (text, msg) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const t = Object.assign(document.createElement("textarea"), { value: text });
    document.body.appendChild(t);
    t.select();
    document.execCommand("copy");
    t.remove();
  }
  toast.success(msg);
};

export const hrs = (h) => (h == null ? "—" : `${Number(h) >= 10 ? Math.round(h) : Number(h).toFixed(1).replace(/\.0$/, "")}h`);
